// extracted by mini-css-extract-plugin
module.exports = {"Container":"Carousel_Container__1X3GQ","ImgDiv":"Carousel_ImgDiv__2GBSx"};